export enum RoutingStatus {
  Hold = 'Pendiente de envío a ruteo',
  OnRouter = 'En ruteador sin planear',
  Planned = 'Planeado en ruteador',
  Created = 'Con embarque generado'
}
